<div class="landing-page">
  <!-- SECTION 1: Hero Banner -->
  <section class="hero-section">
    <div class="decorative-sparkle">
      <i class="pi pi-sparkles"></i>
    </div>
    <div class="hero-content">
      <div class="heading-wrapper">
        <h1 class="hero-heading">
          <span class="highlight-wrap">
            <img src="assets/images/direct-apply-landing.png" alt="" class="hero-highlight-img" aria-hidden="true" />
            <span class="highlight-text">Take the First Step Towards Your Dream University</span>
          </span>
        </h1>
      </div>
      <div style="width:93%">
        <p class="hero-subtext">
        One form, hundreds of universities, and a team that stays with you till you get in. Your journey starts right
        here.
      </p>
      </div>
     
    </div>
  </section>

  <!-- SECTION 2: Steps to Follow -->
  <section class="steps-section">
    <div class="bg-illustration">
      <img src="assets/images/GraduationCap.png" alt="Graduation Cap Background" aria-hidden="true" />
    </div>

    <div class="steps-container">
      <h2 class="section-title">
        Steps to follow
        <div class="title-underline"></div>
      </h2>

      <div class="featured-step-wrapper">
        <div class="featured-step-card">
          <div class="icon-wrapper">
            <i class="pi pi-list"></i>
          </div>
          <div class="featured-text">
            <h3>Start Your Application Journey</h3>
            <p>Choose the application method that works best for you.</p>
          </div>
        </div>
        <div class="pointer-arrow">
          <img src="assets/images/arrow.png" alt="Arrow pointing right">
          <span class="handwritten-text">You are currently here</span>
          <p style=" color: #000086;
    width: 79%;
    margin-left: 34px;">Pick the package that works best for you : Self Apply with a consultant or add an Expert Session with a premium counsellor</p>
        </div>
      </div>

      <div class="steps-grid">
        <!-- <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">01</div>
          </div>
          <h4 class="step-title">Discover colleges</h4>
          <p class="step-desc">Explore College Discovery to uncover universities that truly fit your style and
            aspirations, helping you find the perfect place to thrive academically and socially.</p>
        </div> -->

        <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">01</div>
          </div>
          <h4 class="step-title">Fill in the Application Form</h4>
          <p class="step-desc">Complete your application form and upload all required documents</p>
        </div>

        <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">02</div>
          </div>
          <h4 class="step-title">Review your college cart</h4>
          <p class="step-desc">Review your selected universities and courses. Check the universities you've picked for Direct Apply — you can choose up to 5 at a time.
          </p>
        </div>

        <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">03</div>
          </div>
          <h4 class="step-title">Payment</h4>
          <p class="step-desc">Review your order and pay securely. Once done, our dedicated experts get assigned to your application.</p>
        </div>

        <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">04</div>
          </div>
          <h4 class="step-title">Confirmation</h4>
          <p class="step-desc">Your application has been received and Your expert will be in touch with next steps within 24 hours.</p>
        </div>

        <div class="step-card">
          <div class="step-header">
            <div class="icon-wrapper-light"><i class="pi pi-list"></i></div>
            <div class="step-number">05</div>
          </div>
          <h4 class="step-title">Track your application</h4>
          <p class="step-desc">Track the status of every application from your dashboard. You'll always know what's happening and what's next.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION 3: Choose How You Want to Proceed -->
  <section class="proceed-section">
    <img src="assets/images/purple-circle.png" class="bg-purple-circle" aria-hidden="true" />
    <img src="assets/images/yellow-circle.png" class="bg-yellow-circle" aria-hidden="true" />
    <img src="assets/images/yellow-line.png" class="bg-yellow-arc" aria-hidden="true" />

    <div class="proceed-container">
      <div class="proceed-title-row">
        <img src="assets/images/landing-page.png" alt="Illustration" class="proceed-illustration">
        <h2 class="section-title">
          Choose how you want to proceed
          <div class="title-underline"></div>
        </h2>
      </div>

      <div class="cards-wrapper">
        <!-- Card 1: Self Direct Apply -->
        <div class="card-option-one">
          <h3 class="card-heading-one">Direct Apply</h3>
          <p class="card-subtext-one">Self Apply - Fill in one form and apply directly to your chosen universities. Our support team is always on chat if you need us. Start your application</p>
          <button class="card-button-one" (click)="onStart('standard')">Start application &rarr;</button>
        </div>

        <!-- Card 2: Self Apply + Expert -->
        <div class="card-option-two">
          <h3 class="card-heading-two">Direct Apply + <span>30 mins session with premium counsellor</span></h3>
          <p class="card-subtext-two">Get confident with a premium counselling session. Everything in Direct Apply, plus a 30-minute session with a premium counsellor to sort your strategy before you submit. Start applying</p>
          <button class="card-button-two" (click)="onStart('expert')">Start application &rarr;</button>
        </div>
      </div>
    </div>
  </section>
</div>